import { Card } from 'primereact/card';
import { useState } from 'react';
import { Button } from 'primereact/button';
import { ContactUsDialog } from '../components/contact-us-dialog';
import { aboutContent } from '../content/website-content';
import { WebsiteDocument } from '../components/website-document';
import '../assets/about.css';
import '../assets/theme-content.css';

export default function AboutPage() {
    const [contactVisible, setContactVisible] = useState(false);
    return <div className="about-page theme-content">
        <h2 className="page-title public-page-title">About</h2>
        <div className="about-content">
            <section aria-labelledby="about-me-heading" className="surface-card border-1 surface-border border-round p-4 md:p-5">
                <div className="about-introduction">
                    <div>
                        <h2 id="about-me-heading" className="mt-0">About me</h2>
                        <p className="text-lg line-height-3 mb-0">{aboutContent.introduction}</p>
                    </div>
                    <img src="/assets/photo-about.png" alt="Olha Popivnenko" className="about-photo border-round" />
                </div>
            </section>
            <section aria-labelledby="qualifications-heading">
                <Card className="border-1 surface-border shadow-none">
                    <h2 id="qualifications-heading" className="mt-0">Education &amp; qualifications</h2>
                    <ul className="about-qualifications">{aboutContent.qualifications.map(qualification => <li key={qualification}>{qualification}</li>)}</ul>
                </Card>
            </section>
            <section aria-labelledby="experience-heading">
                <Card className="border-1 surface-border shadow-none">
                    <h2 id="experience-heading" className="mt-0">Professional experience</h2>
                    <WebsiteDocument blocks={aboutContent.experience} />
                </Card>
            </section>
            <section aria-labelledby="mindset-heading">
                <Card className="border-1 surface-border shadow-none">
                    <h2 id="mindset-heading" className="mt-0">My mindset as a trainer</h2>
                    <WebsiteDocument blocks={aboutContent.mindset} />
                </Card>
            </section>
            <section aria-labelledby="connect-heading">
                <Card className="border-1 surface-border shadow-none">
                    <h2 id="connect-heading" className="mt-0">Connect</h2>
                    <p className="line-height-3">Have a question about the website?{' '}
                        <Button label="Send an email" link className="about-email-link" onClick={() => setContactVisible(true)}/>
                    </p>
                    <p className="line-height-3">{aboutContent.connect}</p>
                    <div className="flex flex-wrap gap-3">
                        <a href="https://www.instagram.com/olha_popivnenko/" target="_blank" rel="noopener noreferrer"
                            className="p-button p-component p-button-outlined no-underline">
                            <i className="pi pi-instagram mr-2" aria-hidden="true" />
                            <span className="p-button-label">Instagram: @olha_popivnenko</span>
                        </a>
                        <a href="https://www.tiktok.com/@olha_popivnenko" target="_blank" rel="noopener noreferrer"
                            className="p-button p-component p-button-outlined no-underline">
                            <i className="pi pi-video mr-2" aria-hidden="true" />
                            <span className="p-button-label">TikTok: @olha_popivnenko</span>
                        </a>
                    </div>
                </Card>
            </section>
        </div>
        {contactVisible && <ContactUsDialog onHide={() => setContactVisible(false)}/>}
    </div>;
}
